




export default {
  name: 'Settings',
};
